export class VideoCarousel {

    constructor() {
        $(function() {
            $(".video-carousel").on("slide.bs.carousel", function(e) {
                let prev = $(this)
                    .find(".active")
                    .index();
                let next = $(e.relatedTarget).index();
                let video = $("#video-player")[0];

                let carouselId = '';
                if(video && typeof $(video).attr('data-carousel-id') !== 'undefined') {
                    carouselId = $(video).attr('data-carousel-id');
                }


                let videoSlide = $("#video-player")
                    .closest(".carousel-item")
                    .index();
                if (next === videoSlide) {
                    if (video.tagName !== "IFRAME") {
                        window.VideoCarousel.createVideo(video);
                    }
                    if(carouselId) {
                        $('#'+carouselId).addClass('video-slide-active');
                    }

                } else {
                    if (typeof player !== "undefined") {
                        player.pauseVideo();
                    }
                    if(carouselId) {
                        $('#'+carouselId).removeClass('video-slide-active');
                    }

                }
                
            });
        });
    }

     createVideo(video) {
        let youtubeScriptId = "youtube-api";
        let youtubeScript = document.getElementById(youtubeScriptId);
        let videoId = $(video).attr('data-video-id')
        let carouselId = $(video).attr('data-carousel-id')

        if (youtubeScript === null) {
            let tag = document.createElement("script");
            let firstScript = document.getElementsByTagName("script")[0];

            tag.src = "https://www.youtube.com/iframe_api";
            tag.id = youtubeScriptId;
            tag.carouselId = carouselId;
            firstScript.parentNode.insertBefore(tag, firstScript);

            if (document.getElementById(carouselId)) {
                document.getElementById(carouselId).setAttribute('data-youtube-id', videoId);
            }
        }

        window.onYouTubeIframeAPIReady = function() {
            window.player = new window.YT.Player(video, {
                videoId: videoId,
                playerVars: {
                    autoplay: 0,
                    modestbranding: 1,
                    rel: 0
                },
                events: {
                    'onStateChange': window.VideoCarousel.onPlayerStateChange
                }
            });
        };
    }

    onPlayerStateChange(event)
    {
        let carouselId = $(window.player.getIframe()).attr('data-carousel-id');
        if (event.data === window.YT.PlayerState.PLAYING) {
            $('#'+carouselId).addClass('video-playing');
        } else {
            $('#'+carouselId).removeClass('video-playing');
        }

        if (event.data === window.YT.PlayerState.ENDED) {
            window.player.seekTo(0);
            window.player.pauseVideo();
        }
    }

}




